import React from "react";
import PropTypes from "prop-types";
import { Alert as BootstrapAlert } from "react-bootstrap";
import ReactMarkdown from "react-markdown";
import warningIcon from "../../assets/icons/partial-warning.svg";

export const Alert = ({ variant, dismissible, onClose, children, text, className, fontSize }) => {
    return (
        <BootstrapAlert className={`d-flex align-items-center justify-content-between ${className}`} variant={variant} dismissible={dismissible} onClose={onClose}>
            <div className="d-flex align-items-start pt-1">
                <img className="me-2 w-20 " src={warningIcon} fontSize={fontSize || '1.2rem'} />
                <span className="ReactMarkdown w-80">
                    <ReactMarkdown>{text}</ReactMarkdown>
                </span>
            </div>
            <div className="warniing-badge">Unreported</div>
        </BootstrapAlert>
    );
};

Alert.propTypes = {
    variant: PropTypes.oneOf([
        "primary",
        "secondary",
        "success",
        "danger",
        "warning",
        "info",
        "light",
        "dark",
    ]),
    dismissible: PropTypes.bool,
    onClose: PropTypes.func,
    text: PropTypes.string,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    fontSize: PropTypes.string,
};

Alert.defaultProps = {
    variant: "primary",
    dismissible: false,
    onClose: undefined,
};
